import script from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=js"
export * from "./ResponsiveTable.vue?vue&type=script&setup=true&lang=js"

import "./ResponsiveTable.vue?vue&type=style&index=0&id=613b0c9d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-613b0c9d"]])

export default __exports__